module.exports = __webpack_public_path__ + "img/IT0000507001867.c30f36f4.png";